/**
 * Purchase Summary Report Hook
 * @see Sprint 32 - Rapport Sommaire des Achats
 * @see US-32.3 - Frontend Page et Composants
 */

import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getPurchaseSummaryReport } from '../services/purchase-summary-report.service';
import type { PurchaseSummaryReportQuery } from '@bstock/shared';

/**
 * Query key factory for purchase summary report
 */
export const purchaseSummaryReportKeys = {
  all: ['purchase-summary-report'] as const,
  report: (params: PurchaseSummaryReportQuery) =>
    [...purchaseSummaryReportKeys.all, 'report', params] as const,
};

/**
 * Hook to get purchase summary report
 */
export function usePurchaseSummaryReport(params: PurchaseSummaryReportQuery | null) {
  return useQuery({
    queryKey: purchaseSummaryReportKeys.report(params!),
    queryFn: () => getPurchaseSummaryReport(params!),
    enabled: !!params && !!params.dateFrom && !!params.dateTo,
    placeholderData: keepPreviousData,
    staleTime: 60_000, // 1 minute
  });
}
